import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SdAngularJsonAPIMediaHeaderInterceptor implements HttpInterceptor {
	intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const headers = {
			'Content-Type': 'application/vnd.api+json',
			'Accept': 'application/vnd.api+json'
		};

		return next.handle(req.clone(
			{
				setHeaders: headers
			}));
	}
}
